import { useQuery } from '@tanstack/react-query';
import { fetchUserAccount, fetchUserRoleByEmail } from '../services/api';

const useMe = (isOpen=true)=> useQuery({
    queryKey: ['getMe'],
    queryFn: async ()=> await fetchUserAccount(),
    enabled: isOpen
})

const useMeRoles = (email, isOpen=true)=> useQuery({
    queryKey: ['getMeRoles'],
    queryFn: async ()=> await fetchUserRoleByEmail(email),
    enabled: isOpen && Boolean(email)
})

export {
    useMe,
    useMeRoles
}